export default __webpack_public_path__ + "static/media/5.a1bc2a18.jpg";